import { render } from "./CallbackView.vue?vue&type=template&id=2a6c73ce&ts=true"
import script from "./CallbackView.vue?vue&type=script&lang=ts"
export * from "./CallbackView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__